import React, { ReactNode } from 'react';

import { makeClassNames } from '../../../utils/styles';
import './legend-item.scss';

export interface ILegendItem {
  children: ReactNode;
  color?: string;
  title?: string;
  tag?: string;
  separator?: string;
}

const VALID_TAGS = ['span', 'li'];
const FALLBACK_TAG = 'li';

const classNames = (color: string | undefined) =>
  makeClassNames({
    legendItem: 'legend-item',
    color: ['legend-item__indicator', color && `legend-item__indicator${`--color-${color}`}`],
    title: 'legend-item__title',
  });

const LegendItem = ({ color, children, tag, title, separator = ':' }: ILegendItem) => {
  const safeTag = tag ? tag.toLowerCase() : FALLBACK_TAG;
  const Tag = VALID_TAGS.includes(safeTag) ? safeTag : FALLBACK_TAG;
  const cn = classNames(color);

  return (
    // @ts-ignore
    <Tag className={cn.legendItem}>
      {color && <span className={cn.color} />}
      {title && <div className={cn.title}>{title + separator}</div>}
      {children}
    </Tag>
  );
};

export default LegendItem;
